/**
 * locker-marks.js — спостережні ознаки, які їдуть разом із дією курʼєра
 * над посилкою в поштоматі. Дзеркало бекендного app/utils/locker_action_marks.py.
 *
 * Навіщо. «Епіцентрівський сценарій» (пріоритет посилки у списку на вкладення
 * і стеля розміру комірки S→M→L замість S→M→L→XL) вмикає isEpAgent — збіг
 * підрядка «епіцентр» у текстовому полі агента посилки. Сама ознака НІДЕ не
 * зберігалась, тож порахувати заднім числом, скільки посилок її отримали і чи
 * достатньо збігу підрядка, було нічим. Тепер сире значення їде з дією і лягає
 * в журнал поруч із мережею поштомата, яку бекенд підставляє сам.
 *
 * Модуль навмисно ЛИСТКОВИЙ — без жодного імпорту. Поштоматний флоу має дві
 * самостійні реалізації (app_min1 і courier.html, див. docs/LOCKER_FLOW_CASES.md,
 * F-17), і саме тому хелпер спільний: якби кожен екран ніс свою копію, вони
 * розійшлись би тихо, і зведена вибірка поїхала б непомітно — а це гірше за
 * відсутність даних. flows.js сюди не годиться: він тягне ui.js і api.js.
 *
 * Жодне з полів на поведінку екрана не впливає.
 */

/**
 * Скільки символів агента має сенс відправляти.
 *
 * Свідомо БІЛЬШЕ за колонку `parcel_agent VARCHAR(128)`: прапорець «епіцентр»
 * бекенд рахує по повному отриманому тексту (як і isEpAgent на екрані, який не
 * обрізає нічого) і лише потім ріже текст під колонку. Якби ми слали рівно 128,
 * назва на 130 символів із «Епіцентром» у кінці приїхала б без нього — і в
 * даних вийшло б recognized=false там, де екран розпізнав true, тобто хибна
 * відповідь рівно на те питання, заради якого поле збирається.
 */
export const MAX_AGENT_SEND_LEN = 1024;

/** Ідентифікатори екранів — з якої реалізації флоу прийшла дія. */
export const LOCKER_CLIENT_APP_MIN1 = 'app_min1';
export const LOCKER_CLIENT_COURIER = 'courier';

/**
 * Агент (відправник) посилки у вигляді, придатному для відправки з дією.
 *
 * Шлемо СИРИЙ текст, а не «так/ні»: весь сенс у тому, щоб на бекенді побачити
 * реальні написання (латиниця, зайві пробіли, назва з іменем людини) і
 * порівняти їх із тим, як розпізнав екран.
 *
 * Повертає null для посилки без відправника — і це НЕ те саме, що не слати
 * поле взагалі: ключ у тілі запиту має бути завжди, інакше бекенд не відрізнить
 * «у посилки немає відправника» від «курʼєр на старому бандлі».
 *
 * Поле спостережне: значення не впливає ні на що на екрані, а його відсутність
 * не має ламати запит. Тому за будь-якої дивини повертаємо null.
 */
export function parcelAgentForRequest(parcel) {
  try {
    const raw = parcel && parcel.agent;
    if (raw === null || raw === undefined) return null;
    const text = String(raw).trim();
    if (!text) return null;
    return text.slice(0, MAX_AGENT_SEND_LEN);
  } catch {
    return null;
  }
}
